export interface SCEDAInterface {
  nextEvent(event: string): void;
}
